import { queryOptions } from "@tanstack/react-query";

const availableMediaDevicesQueryOptions = (hasMediaAccess: boolean) =>
  queryOptions({
    queryKey: ["media-devices"],
    queryFn: async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices;
    },
    select: (data) => {
      const audioInputDevices = data.filter(
        (device) => device.deviceId && device.kind === "audioinput",
      );
      const videoInputDevices = data.filter(
        (device) => device.deviceId && device.kind === "videoinput",
      );
      const audioOutputDevices = data.filter(
        (device) => device.deviceId && device.kind === "audiooutput",
      );
      return {
        audioInputDevices,
        videoInputDevices,
        audioOutputDevices,
      };
    },
    enabled: hasMediaAccess,
    refetchInterval: 2000, // To detect a new device being plugged in
  });

export default availableMediaDevicesQueryOptions;
